export const MAX_ATTACHMENTS = 1;
export const ACCEPTED_IMAGE_FILE_TYPES = ["image/png", "image/jpeg"];
export const ACCEPTED_VIDEO_FILE_TYPES = [
  "video/quicktime",
  "video/x-flv",
  "video/x-m4v",
  "video/mp4",
  "video/webm",
];
export const MAX_FILE_SIZE = 1024 * 1024 * 1024; // 1GB
export const MAX_FILE_SIZE_LABEL = "1GB";

export const SEARCH_PARAM = "search";
